import {useState, useImperativeHandle, forwardRef} from 'react';
import {Modal, Row, Col, Form, Checkbox, Select, DatePicker, Input, Radio, TreeSelect,Skeleton} from 'antd';
import './index.less'
const CheckboxGroup = Checkbox.Group;
const { Option } = Select;
const {TextArea} = Input;
const FormModal = (prop, ref) => {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('');
    const [formOption, setFormOption] = useState({});
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [initOptionLoading, setInitOptionLoading] = useState(false);
    const [initValue, setInitValue] = useState({});

    useImperativeHandle(ref, () => ({
        form: form,
        setFormOptionList: (list) => {
            console.log(list);
            setFormOption({...formOption, list});
        },
        open: (title, formOption, initValue) => {
            if(formOption.initOption) {
                setInitOptionLoading(true);
                formOption.initOption().then(data => {
                    setInitOptionLoading(false);
                    setFormOption({...formOption, option: {...formOption.option, ...data}});
                })
            } else{
                setFormOption(formOption);
            }
            setTitle(title);
            form.resetFields();
            if(initValue) {
                form.setFieldsValue({...initValue});
                setInitValue({...initValue});
            }
            setVisible(true);
        },
    }));
    const handleOk = () => {
        form.validateFields().then(data => {
            setConfirmLoading(true);
            formOption.submit({...initValue, ...data}, () => {
                setVisible(false);
                setConfirmLoading(false);
            }, () => setConfirmLoading(false))
        })
    };

    const handleCancel = () => {
        setVisible(false);
    };
    const renderFormList = () => {
        let {list = [], rules = {}, option = {}, labelCol = {}} = formOption;
        let filterItem = ({type, prop, label, config, placeholder}) => {
            switch (type) {
                case "checkboxGroup":
                    return (<CheckboxGroup options={option[prop] || []}/>)
                case "tree":
                    return ( <TreeSelect
                        style={{ width: '100%' }}
                        {
                            ...(config || {})
                        }
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeData={option[prop] || []}
                        placeholder={`请选择${label}`}
                        treeDefaultExpandAll
                    />)
                case "datePicker":
                    return (
                        <DatePicker style={{ width: '100%' }} placeholder={`请选择${label}`}/>
                    )
                case "password":
                    return (<Input.Password placeholder={`请输入${label}`}/>)
                case "radio":
                    return (<Radio.Group optionType="button" {...config} buttonStyle="solid" options={option[prop]}/>)
                case "show":
                    return (<Input className="read-only"/>)
                case "textArea":
                    return (<TextArea placeholder={`请输入${label}`}/>)
                case "select":
                    return (
                        <Select style={{ width: '100%' }} {...config} placeholder={`请选择${label}`}>
                            {
                                option[prop].map((value, key) => (
                                    <Option key={key} value={value.value}>{value.label}</Option>
                                ))
                            }
                        </Select>
                    )
                default:
                    return (<Input placeholder={placeholder || `请输入${label}`}/>)
            }
        }
        return list.map((value, key) => {
            let {span = 24, prop, label} = value;
            return (<Col key={key} span={span}>
                {
                    value.render ? value.render() :
                        <Form.Item labelCol={labelCol} name={prop} label={label} rules={rules[prop] || []}>
                        {
                            filterItem(value)
                        }
                    </Form.Item>
                }
            </Col>)
        })
    }
    return (
        <Modal
            title={title}
            visible={visible}
            onOk={handleOk}
            {
                ...(prop.config || {})
            }
            confirmLoading={confirmLoading}
            onCancel={handleCancel}
        >
            <Skeleton loading={initOptionLoading} active>
                <Form form={form} name="control-hooks"><Row gutter={12}>{renderFormList()}</Row></Form>
            </Skeleton>
        </Modal>
    )
}
export default forwardRef(FormModal);
